import { ToolDatamatrix } from '../model/toolDatamatrix.model';
import { WizardModalComponent } from '@app/shared/components';
import { ToolLifecycleFormComponent } from '@app/tool/tool-form-modal/forms';
import { ToolDetailsFormComponent } from '@app/tool/tool-form-modal/forms';
import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewChild, } from '@angular/core';
import { EquipmentService } from '@app/core/services/equipment.service';
import { ToolService } from '@app/core/services/tool.service';
import * as _ from 'lodash';

import { Equipment } from '@models/equipment.model';
import { User } from '@app/shared/models';
import { Line } from '@models/line.model';
import { PartNumber } from '@models/partNumber.model';
import { ToastsManager } from "@app/shared/util/toastr.service";
import { TranslateParser, TranslateService } from "@ngx-translate/core";
import { ToolFormModel } from "@app/tool/tool-form-modal/tool-create.model";
import { Log } from "ng2-logger";
import { PartNumbersService } from "@services/part-numbers.service";
import { Tool } from "@app/tool/model/tool.model";
import { ToolPartNumbersFormComponent } from "@app/tool/tool-form-modal/forms/tool-part-numbers-form/tool-part-numbers-form.component";
import {
    ToolMainEquipmentFormComponent
} from "@app/tool/tool-form-modal/forms/tool-main-equipment-form/tool-main-equipment-form.component";
import {
    ToolSecondaryEquipmentFormComponent
} from "@app/tool/tool-form-modal/forms/tool-secondary-equipment-form/tool-secondary-equipment-form.component";
import { ToolInsertionCyclesFormComponent } from './forms/tool-insertion-cycles-form/tool-insertion-cycles-form.component';
import { InsertionCyclesService } from '@app/core/services/insertion-cycles.service';
import {
    ToolSpecialIdentifiersFormComponent
} from "@app/tool/tool-form-modal/forms/tool-special-identifiers-form/tool-special-identifiers-form.component";
import { ToolsetCodesFormComponent } from './forms/toolset-codes-form/toolset-codes-form.component';

@Component({
    selector: 'app-tool-create-modal',
    templateUrl: 'tool-create-modal.component.html',
    styleUrls: ['tool-create-modal.component.scss']
})
export class ToolCreateModalComponent implements AfterViewInit {
    _logger = Log.create(ToolCreateModalComponent.name);

    @ViewChild(WizardModalComponent, {static: false}) wizardModal: WizardModalComponent;
    // 1st Step
    @ViewChild(ToolDetailsFormComponent, {static: false}) toolDetailsForm: ToolDetailsFormComponent;
    // 2nd Step
    @ViewChild(ToolSpecialIdentifiersFormComponent, {static: false})
    toolSpecialIdentifiersFormComponent: ToolSpecialIdentifiersFormComponent;
    // 3rd Step
    @ViewChild(ToolLifecycleFormComponent, {static: false}) toolLifecycleForm: ToolLifecycleFormComponent;
    // 4th Step
    @ViewChild(ToolPartNumbersFormComponent, {static: false}) toolPartNumber: ToolPartNumbersFormComponent;
    // 5th Step
    @ViewChild(ToolInsertionCyclesFormComponent, {static: false}) toolInsertionCyclesForm: ToolInsertionCyclesFormComponent;
    // 6th Step
    @ViewChild(ToolMainEquipmentFormComponent, {static: false}) toolMainEquipmentForm: ToolMainEquipmentFormComponent;
    // 7th Step
    @ViewChild(ToolSecondaryEquipmentFormComponent, {static: false}) toolSecondaryEquipmentForm: ToolSecondaryEquipmentFormComponent;
    // 8th Step
    @ViewChild(ToolsetCodesFormComponent, {static: false}) toolsetCodesForm: ToolsetCodesFormComponent;


    @Input() tool = new ToolFormModel();


    @Output() createTool = new EventEmitter();
    @Output() onUpdate = new EventEmitter();
    @Output() onDelete = new EventEmitter();

    @Output() onClose = new EventEmitter();

    toolDatamatrix: ToolDatamatrix[] = [];
    toolBackups: Tool[] = [];

    selectedMainLine: Line = new Line();
    selectedOwner: User = new User();
    availableParts = new Array<any>();
    availableInsertionCycles = new Array<any>();
    availableMainEquipments = new Array<Equipment>();
    availableSecondaryEquipments = new Array<Equipment>();
    selectedSecondaryEquipments = new Array<Equipment>();

    selectedStep: number;
    duplicateMode = false;
    isLoading = false;

    get isSPI() {
        if (this.selectedMainLine) {
            return !!this.selectedMainLine.isSPI
        } else {
            return false;
        }
    };

    private get specialIdentifiersStepIndex() {
        return 1;
    }

    private get lifecycleStepIndex() {
        return 2;
    }

    private get partNumbersStepIndex() {
        return 3;
    }

    private get insertionCyclesStepIndex() {
        return 4;
    }

    private get mainEquipmentsStepIndex() {
        return this.isSPI ? 5 : 4;
    }

    private get codesStepIndex() {
        return this.isSPI ? 7 : 6;
    }

    private get toolBackupsStepIndex() {
        return this.isSPI ? 9 : 8;
    }

    constructor(private equipmentService: EquipmentService,
                private toastr: ToastsManager,
                private translateService: TranslateService,
                private partService: PartNumbersService,
                private translateParser: TranslateParser,
                private cdr: ChangeDetectorRef,
                private toolService: ToolService,
                private insertionCyclesService: InsertionCyclesService) {
    }

    onStepChange(stepIndex) {
        this.selectedStep = stepIndex;
        if (stepIndex === this.specialIdentifiersStepIndex) {
            return;
        }

        if (stepIndex === this.lifecycleStepIndex) {
            this.tool.setData(this.toolDetailsForm.getFormValue());
            this.tool.setData(this.toolSpecialIdentifiersFormComponent.getFormValue());
            this.onSelectLine(this.toolDetailsForm.selectedLine);
            this.onSelectOwner(this.toolDetailsForm.selectedOwner);
            return;
        }

        if (stepIndex === this.partNumbersStepIndex) {
            const lifecycle = this.toolLifecycleForm.getFormValue();
            lifecycle.currentProductionTime *= this.toolLifecycleForm.currentProductionTimeMultiplier;
            this.tool.setData(lifecycle);
            return;
        }

        if (this.isSPI && stepIndex === this.insertionCyclesStepIndex) {
            this.getInsertionCyclesByLineAndByPartNumbers(this.selectedMainLine, this.tool.partNumbers);
            return;
        }

        if (stepIndex === this.mainEquipmentsStepIndex) {
            this.getEquipmentsByPartNumbers(this.tool.partNumbers);
            if (this.toolInsertionCyclesForm) {
                this.tool.setData(this.toolInsertionCyclesForm.getFormValue());
            }
            return;
        }

        if (stepIndex === this.codesStepIndex) {
            const changedSetSize = this.tool.isSet && this.tool.setSize !== this.toolsetCodesForm.getSetSize();
            if (!this.toolsetCodesForm.isInitialized || changedSetSize) {
                this.toolsetCodesForm.initializeForms();
            } else {
                this.toolsetCodesForm.revalidate();
            }
            return;
        }

        if (stepIndex === this.toolBackupsStepIndex) {
            this.getToolBackups(this.tool);
        }
    }

    onSelectLine(line) {
        this.selectedMainLine = line;
        this.getPartNumbersByLine(this.selectedMainLine);
    }

    onSelectOwner(owner) {
        this.selectedOwner = owner;
    }

    onWizardSubmit() {
        this.isLoading = true;
        this.tool.setData(this.toolsetCodesForm.getFormValue());
        this.tool.lineId = this.selectedMainLine.id;
        this.tool.ownerId = this.selectedOwner.id;
        this._logger.info("onWizardSubmit:: Raw submitted tool", this.tool);
        const toolDTO = this.tool.toDTO();
        this._logger.info("onWizardSubmit:: Creating tool [DTO]", JSON.stringify(toolDTO));
        this.toolService.createTool(toolDTO).subscribe((data) => {
                this._logger.info("onWizardSubmit:: API Returned data", data);
                let createdToolOrSet;
                if (data[0].sets) {
                    createdToolOrSet = data[0].sets[0].tools[0];
                } else if (data[0].tools) {
                    createdToolOrSet = data[0].tools[0];
                }
                this.tool.duplicateId = this.tool.id;
                this.tool.id = createdToolOrSet.id;
                this.tool = _.clone(this.tool);
                this.toolService.reloadTools();
                this.getToolDataMatrix(createdToolOrSet);
                this.toastr.success(this.buildCreateMessage(createdToolOrSet.name));
                this.isLoading = false;
                this.wizardModal.next();
            },
            (error) => {
                this._logger.info("onWizardSubmit:: API Returned error", error);
                this.isLoading = false;
            });
    }

    onWizardCancel() {
        this.reset();
        this.close();
        this.toolService.getTools();
    }

    open(duplicateMode = false) {
        this.duplicateMode = duplicateMode;
        this.wizardModal.open();
    }

    close() {
        this.reset();
        this.wizardModal.close();
        this.onClose.emit(this.tool);
    }

    reset() {
        this.tool = new ToolFormModel();
        this.selectedOwner = new User();
        this.selectedMainLine = new Line();
        if (this.toolDetailsForm) {
            this.toolDetailsForm.resetForm();
        }
        if (this.toolsetCodesForm) {
            this.toolsetCodesForm.resetForm();
        }
        if (this.toolLifecycleForm) {
            this.toolLifecycleForm.resetForm();
        }

        if (this.toolSpecialIdentifiersFormComponent) {
            this.toolSpecialIdentifiersFormComponent.resetForm();
        }

        if (this.toolInsertionCyclesForm) {
            this.toolInsertionCyclesForm.resetForm();
        }

        this.resetToolConfigs();
        this.duplicateMode = false;
        this.wizardModal.reset();
    }

    onLineChange(line: any) {
        this.tool.insertionCycles.length = 0;
        if (this.selectedMainLine && this.selectedMainLine.id && line && line.id && this.selectedMainLine.id !== line.id) {
            this.resetToolConfigs();
        }
        this.selectedMainLine = line;
    }

    private resetToolConfigs() {
        this.tool.partNumbers = [];
        this.tool.insertionCycles = [];
        this.tool.mainEquipment = [];
        this.tool.secondaryEquipment = [];
        this.selectedSecondaryEquipments = [];
        this.availableParts = [];
        this.availableMainEquipments = [];
        this.availableSecondaryEquipments = [];
    }

    private getToolDataMatrix(toolOrSet) {
        this._logger.info('getToolDataMatrix:: Retrieving tool datamatrixes', toolOrSet);
        this.toolService.getToolDatamatrix(toolOrSet.id).subscribe(toolDM => {
            this._logger.info('getToolDataMatrix:: API returned data', toolDM);
            this.toolDatamatrix = toolDM;
        });
    }

    private getPartNumbersByLine(line: Line) {
        this.partService.getPartNumbersByLine(line).subscribe((data) => {
            this.availableParts = data.items;
        });
    }

    private getInsertionCyclesByLineAndByPartNumbers(line: Line, partNumbers: PartNumber[]) {
        if (!line.isSPI || partNumbers.length === 0) {
            this.tool.insertionCycles = [];
            this.availableInsertionCycles = [];
            return;
        }
        this.insertionCyclesService.getInsertionCyclesByLineAndByPartNumbers(line.id, partNumbers).subscribe((data) => {
            this.availableInsertionCycles = data.items;

            _.remove(this.tool.insertionCycles, (ic) => {
                return !_.some(this.availableInsertionCycles, (availableIC) => availableIC.id === (<any>ic).id)
            })
        });
    }

    private getEquipmentsByPartNumbers(partNumbers: PartNumber[]) {
        if (partNumbers.length === 0) {
            this.tool.mainEquipment = [];
            this.availableMainEquipments = [];
            return;
        }
        this.equipmentService.getEquipmentByPartNumbers(partNumbers).subscribe((data) => {
            this.availableMainEquipments = _.filter(data.equipment, (eq: Equipment) => eq.line.id === this.selectedMainLine.id);
            this.availableSecondaryEquipments = _.filter(data.equipment, (eq: Equipment) => eq.line.id !== this.selectedMainLine.id);

            _.remove(this.tool.mainEquipment, (mainEquip) => {
                return !_.some(this.availableMainEquipments, (availableMainEquip) =>
                    availableMainEquip.id === (<any>mainEquip.id))
            });
            _.remove(this.tool.secondaryEquipment, (secondaryEquip) => {
                return !_.some(this.availableSecondaryEquipments, (availableSecondaryEquip) =>
                    availableSecondaryEquip.id === (<any>secondaryEquip.id))
            });

        });
    }

    private getToolBackups(tool: ToolFormModel) {
        const toolId = this.duplicateMode ? this.tool.duplicateId : this.tool.id;
        this._logger.info('getToolBackups:: Retrieving backups for toolId=', toolId);
        this.toolService.getToolBackups(toolId).subscribe(data => {
            this._logger.info('getToolBackups:: API returned data', data);
            this.toolBackups = data;
        });
    }

    get toolDetailsValid() {
        return this.toolDetailsForm ? this.toolDetailsForm.isFormValid : false;
    }

    get toolLifecycleValid() {
        return this.toolLifecycleForm ? (this.toolLifecycleForm.isFormValid || false) : false;
    }

    buildCreateMessage(toolName) {
        const message = this.translateService.instant('admin.tools.toasts.created');
        return this.translateParser.interpolate(message, {toolName: toolName});
    }

    ngAfterViewInit(): void {
        this.cdr.markForCheck();
    }
}
